import Loadable from 'react-loadable';
import Loading from '../shared/Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "MultiPartFields" */ './MultiPartFields'),
  loading: Loading,
});
